import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { usePageTitle } from "@/hooks/use-page-title";
import { Home } from "lucide-react";
import { Link } from "wouter";
import healthWalletLogo from "@assets/generated_images/healthwallet_shield_heart_logo.png";

export default function NotFound() {
  usePageTitle("Page Not Found", "The page you are looking for could not be found on HealthWallet.");
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background">
      <div className="flex items-center gap-3 mb-8">
        <img 
          src={healthWalletLogo} 
          alt="HealthWallet Logo" 
          className="h-12 w-12 object-contain"
          width="1024"
          height="1024"
          data-testid="img-notfound-logo"
        />
        <span className="text-2xl font-bold">HealthWallet</span>
      </div>
      
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6 text-center">
          <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-xl font-semibold mb-2">Page Not Found</h2>
          <p className="text-muted-foreground mb-6">
            The page you're looking for doesn't exist or has been moved.
          </p>
          
          <Link href="/" className="min-h-[44px] inline-flex items-center">
            <Button className="min-h-[44px]" data-testid="button-home">
              <Home className="h-4 w-4 mr-2" />
              Return Home
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
